import React from 'react';
import { AddDocumentDialog, IAddDocumentDialogProps } from '../schedule/AddDocumentDialog';

class AddCommentDialog extends React.Component<IAddDocumentDialogProps> {
  constructor(props: IAddDocumentDialogProps) {
    super(props);
  }

  render() {
    return <AddDocumentDialog minWidth='240px' minHeight='288px' {...this.props} />;
  }
}

export default AddCommentDialog;
